module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-xlarge.50ace152.jpg";